'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_StoreGroupView$$anon$7() {
  this.bzV = null;
  this.bzW = false;
}
export { $c_Lpresto_StoreGroupView$$anon$7 as $c_Lpresto_StoreGroupView$$anon$7 };
$p = $c_Lpresto_StoreGroupView$$anon$7.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_StoreGroupView$$anon$7;
/** @constructor */
function $h_Lpresto_StoreGroupView$$anon$7() {
}
export { $h_Lpresto_StoreGroupView$$anon$7 as $h_Lpresto_StoreGroupView$$anon$7 };
$h_Lpresto_StoreGroupView$$anon$7.prototype = $p;
$p.P = (function() {
  if ((!this.bzW)) {
    this.bzV = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_T8($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$());
    this.bzW = true;
  }
  return this.bzV;
});
var $d_Lpresto_StoreGroupView$$anon$7 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_StoreGroupView$$anon$7, "presto.StoreGroupView$$anon$7", ({
  RY: 1,
  a: 1,
  i: 1
}));
export { $d_Lpresto_StoreGroupView$$anon$7 as $d_Lpresto_StoreGroupView$$anon$7 };
//# sourceMappingURL=presto.-Store-Group-View$$anon$7.js.map
